var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-bread-crumb"},[_c('Breadcrumb',{style:({fontSize: `${_vm.fontSize}px`})},_vm._l((_vm.list),function(item){return _c('BreadcrumbItem',{key:`bread-crumb-${item.name}`,attrs:{"to":item.to}},[_vm._v(" "+_vm._s(_vm.showTitle(item))+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }